// extracted by mini-css-extract-plugin
module.exports = {"loading":"app-frame_loading__IYpVs","error":"app-frame_error__1qQ3p"};